import PropTypes from "prop-types"

export const WidgetDataType = PropTypes.shape({
  __t: PropTypes.string,
  __v: PropTypes.number,
  _id: PropTypes.string,
  id: PropTypes.string,
  alias: PropTypes.string,
  createdAt: PropTypes.string,
  usedAt: PropTypes.string,
  dashboard: PropTypes.string,
  defaultParams: PropTypes.string,
  scope: PropTypes.string,
  screen: PropTypes.string,
  widget: PropTypes.string
})

export const WidgetViewModelType = PropTypes.shape({
  id: PropTypes.string,
  alias: PropTypes.string,
  dashboard: PropTypes.string,
  subscription: PropTypes.object,
  title: PropTypes.string
})

export const WidgetSubscriptionsTypes = PropTypes.shape({
  asset_list: PropTypes.string,
  customer_list: PropTypes.string,
  start_date_list: PropTypes.string,
  end_date_list: PropTypes.string
})
